<script>
  import { _ } from 'svelte-i18n'
  import { modals, flash_content, detected_fonts, business_subscription_active, user_uploaded_fonts_loading_state } from '../../stores'
  import { deleteFontFiles } from '../../services/font_files'
  import { loadUserContentData } from '../../services/user'
  import UploadedFontsList from '../UploadedFontsList.svelte'
  import Blink from '../../elements/Blink.svelte'
  import Modal from '../../elements/Modal.svelte'
  import Button from '../../elements/Button.svelte'
  
  let show_delete_error = false
  let is_deleting = false
  
  $: uploaded_fonts = ($detected_fonts || []).filter(font => font.uploaded && font.file_name)
  $: has_uploaded_fonts = uploaded_fonts.length > 0
  
  const modal_id = 'manageUploadedFonts'

  async function handleDelete(event) {
    is_deleting = true
    let font = event.detail
    console.log('User - deleting uploaded font:', font.file_name)
    if (!font.file_name) { 
      console.warn('No file name exists, cannot delete font')
      return 
    }

    show_delete_error = false

    try {
      const response = await deleteFontFiles([font.file_name])
      
      if (!response.data.success) {
        show_delete_error = true
        console.error('Failed to delete font:', response.data.delete_errors)
      } else {
        // Update detected_fonts store to remove uploaded font and set uploaded: false for non-uploaded fonts
        detected_fonts.update(fonts => 
          fonts.map(f => {
            if (f.postscript_name === font.postscript_name && f.source !== 'uploaded') {
              return { ...f, uploaded: false };
            }
            return f;
          }).filter(f => f.postscript_name !== font.postscript_name || f.source !== 'uploaded')
        )
        
        // Set is_deleting to false immediately after successful deletion
        is_deleting = false
        
        $flash_content = $_('flashes.userDeletedFont')
      }
    } catch (error) {
      console.error("Error with delete font request:", error)
      show_delete_error = true
      is_deleting = false
    }
  }
  
  const handleReloadFonts = () => {
    user_uploaded_fonts_loading_state.setLoading()
    // wait 1 second
    setTimeout(() => {
      // Need to reload all user content data to be applied to uploaded fonts
      loadUserContentData()
    }, 1000)
  }

  const resetModalVars = () => {
    show_delete_error = false
  }
</script>

<Modal large id={modal_id} on:modalClosed={resetModalVars} flush_header>
  <span slot="header">
    {@html $_('modals.manageUploadedFonts.title')}
  </span>

  <span slot="content">
    {#if has_uploaded_fonts}
      <p class="info">
        {@html $_('modals.manageUploadedFonts.description')}
      </p>
      
      {#if show_delete_error}
        <div class="error_deleting">
          <p>{$_('modals.manageUploadedFonts.deleteError')}</p>
        </div>
      {/if}
      
      <UploadedFontsList is_editing={true} on:fontDelete={handleDelete} is_deleting={is_deleting}/>
    {:else if $user_uploaded_fonts_loading_state.loading}
      <div class="state_info loading">
        <Blink><h3>Loading uploaded fonts...</h3></Blink>
      </div>
    {:else if $user_uploaded_fonts_loading_state.error}
      <div class="state_info error_loading">
        <h3>Error loading fonts</h3>
        <p>There was an error loading your uploaded fonts ({$user_uploaded_fonts_loading_state.error}).</p>
      </div>
    {:else}
      <div class="state_info">
        <h3>{$_('modals.manageUploadedFonts.emptyTitle')}</h3>
        {#if $business_subscription_active}
          {@html $_('modals.manageUploadedFonts.emptyState')}
        {:else}
          {@html $_('modals.manageUploadedFonts.emptyStatePro')}
        {/if}
      </div>
    {/if}
  </span>
  
  <span slot="footer" class="footer">
    {#if $user_uploaded_fonts_loading_state.error}
      <Button kind="accent" on:click={handleReloadFonts}>Retry loading</Button>
    {/if}
    <Button kind="outline" on:click={() => {modals.close(); resetModalVars()}}>{$_('buttons.close')}</Button>
  </span>

</Modal>

<style>
  .info {
    margin-bottom: 2rem;
  }
  .error_deleting {
    margin-bottom: 2rem;
    padding: 1rem;
    background-color: var(--c-danger-bg);
    border-radius: 0.5rem;
    color: var(--c-danger);
  }
  .footer {
    display: flex;
    margin-top: 2rem;
    flex-direction: row;
    gap: 1.5rem;
  }
  .state_info {
    padding: 2rem 1.5rem;
    background-color: var(--c-bg);
    border-radius: 1rem;
    color: var(--c-text);
  }
  .state_info h3 {
    margin-bottom: 1rem;
    color: var(--c-text);
  }
  .state_info.error_loading h3 {
    color: var(--c-danger);
  }
</style> 